/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, select, delay } from 'redux-saga/effects';

import AT from '../constants/action-types';
import { fetchDeviceStatuses } from '../api';
import { put, call } from 'redux-saga/effects';

/**
 * Device online state for the provider the token is scoped to.
 *
 * The old `/status/iot-device-statuses/:serviceProviderId` took the provider as
 * a path parameter and the poll was started by the cross-tenant admin console,
 * once per provider it had listed. There is one provider per session now, so the
 * poll starts once the app has loaded it and refreshes until the next reload.
 *
 * Two actions carry the same payload: the dashboard's kiosk cards read the flat
 * `devices` list, the status page reads it grouped under the provider.
 */
function* processDeviceStatus(serviceProvider: any) {
  const result: any = yield call(fetchDeviceStatuses);
  if (result.httpStatus !== 200) {
    return;
  }
  yield put({ type: AT.FETCH_IOT_DEVICE_STATUS_DONE, devices: result.data.items });
  yield put({
    type: AT.FETCH_DEVICE_STATUSES_DONE,
    devices: result.data.items,
    serviceProvider
  });
}

function* pollDeviceStatus(): any {
  while (true) {
    const provider = yield select((s: any) => s.serviceProviders.myProvider);
    // Nothing to attribute the statuses to until the provider has loaded.
    if (provider) {
      try {
        yield processDeviceStatus(provider);
      } catch (e) {
        // Status is decoration; a failed poll must not tear down the root saga.
      }
    }
    yield delay(40000);
  }
}

export function* providerDeviceStatusSaga() {
  // `takeLatest` restarts the poll on every reload rather than stacking one
  // more loop on top of the last.
  yield takeLatest(AT.APP_INIT_COMPLETED, pollDeviceStatus);
}
